import PropTypes from 'prop-types';
import { Row, Col, Spin } from 'antd';
import { useState, useEffect } from 'react';
import { INDICADOR_MONITOREOS, INDICADOR_VISITAS } from 'constants/monitoringHomeTypes';
import ActiveUsersCard from '../ActiveUsersCard/ActiveUsersCard';
import FlipCard from './FlipCard/FlipCard';
import { CardLabel } from '../CardLabel/CardLabel';
import './Indicadores.scss';

const Indicadores = ({ indicatorsData, handphone, loading, handleGetFileUriSvg }) => {
  const [activeUsers, setActiveUsers] = useState([]);
  const [monitoringArray, setMonitoringArray] = useState([]);
  const [visitasArray, setVisitasArray] = useState([]);

  useEffect(() => {
    const renderActivesUsers = () => {
      try {
        if (indicatorsData) {
          setActiveUsers(indicatorsData?.[0]);
          setMonitoringArray(indicatorsData?.[1]);
          setVisitasArray(indicatorsData?.[2]);
        }
      } catch (error) {
        console.log('Error en desestructurar datos de indicadores', error);
      }
    };

    renderActivesUsers();
  }, [loading, indicatorsData]);
  // console.log('Visitas', visitasArray, indicatorsData);

  return (
    <div>
      {loading ? (
        <Spin />
      ) : (
        <Row style={{ display: 'flex', flexWrap: 'wrap' }}>
          {activeUsers?.length > 0 ? (
            <Col xs={24} sm={24} md={5}>
              <ActiveUsersCard
                className="modules-cards-home"
                movilData={activeUsers?.[0]}
                webData={activeUsers?.[1]}
              />
            </Col>
          ) : null}
          {monitoringArray?.length > 0 ? (
            <Col xs={24} sm={24} md={monitoringArray?.length > 0 ? 19 : 22}>
              <Row>
                <Col span={24}>
                  <CardLabel nameLabel={INDICADOR_MONITOREOS} />
                </Col>
              </Row>
              {monitoringArray && (
                <Row gutter={16}>
                  {monitoringArray.map((type) => (
                    <Col key={type.id} xs={24} sm={24} md={monitoringArray.length === 3 ? 8 : 12}>
                      <FlipCard
                        detalle={type.detalle}
                        nombre={type.nombre}
                        resumen={type.resumen}
                        handleGetFileUriSvg={handleGetFileUriSvg}
                        llave={type.id}
                        idTipo={type.idTipo}
                      />
                    </Col>
                  ))}
                </Row>
              )}
            </Col>
          ) : null}
        </Row>
      )}
      {loading ? (
        <Spin />
      ) : (
        <Row gutter={24} style={{ marginTop: '40px' }}>
          {visitasArray ? (
            <Col span={20}>
              <Row>
                <Col span={24}>
                  {visitasArray?.length > 0 && <CardLabel nameLabel={INDICADOR_VISITAS} />}
                </Col>
              </Row>
              {visitasArray && (
                <Row gutter={16}>
                  {visitasArray?.map((type) => (
                    <Col key={type.id + monitoringArray.length} xs={24} sm={24} md={12}>
                      <FlipCard
                        detalle={type.detalle}
                        nombre={type.nombre}
                        resumen={type.resumen}
                        handleGetFileUriSvg={handleGetFileUriSvg}
                        llave={type.id + monitoringArray.length}
                        idTipo={type.idTipo}
                      />
                    </Col>
                  ))}
                </Row>
              )}
            </Col>
          ) : null}
          <Col xs={8} sm={24} md={4}>
            <div style={{ position: 'relative', textAlign: 'center', width: 'fit-content' }}>
              <img
                className="image-corner"
                src={handleGetFileUriSvg(handphone)}
                alt=""
                height="40%"
                width="100%"
              />
            </div>
          </Col>
        </Row>
      )}
    </div>
  );
};

export default Indicadores;

Indicadores.propTypes = {
  indicatorsData: PropTypes.arrayOf(
    PropTypes.shape({
      idTipo: PropTypes.number.isRequired,
      nombre: PropTypes.string.isRequired,
      detalle: PropTypes.arrayOf(
        PropTypes.shape({
          nombreEstado: PropTypes.string.isRequired,
          total: PropTypes.number.isRequired
        })
      ).isRequired,
      resumen: PropTypes.shape({
        img_64: PropTypes.string.isRequired,
        total: PropTypes.number.isRequired,
        urlImagen: PropTypes.string.isRequired
      }).isRequired
    }).isRequired
  ).isRequired,
  handphone: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  handleGetFileUriSvg: PropTypes.func.isRequired
};
